<div class="container-fluid p-0">
    <div class="main-block row">
        <div class="col-12">
            <div class="login-card">
                <div class="theme-form login-form iq-blog-box">
                    <h4 *ngIf="router.url==='/registration'">{{'REGISTRATION' |translate}}</h4>
                    <h4 *ngIf="router.url==='/login'">Login</h4>
                    <div class="form-group">
                        <label>{{ 'LOGIN_EMAIL' | translate }}</label>
                        <div class="input-group">
                            <span class="input-group-text">
                                <i class="fa fa-envelope"></i>
                            </span>
                            <input name="email" class="form-control" [(ngModel)]="loginForm.email"  type="text" placeholder="{{ 'LOGIN_EMAIL' | translate }}">
                        </div>
                    </div>
                    <div class="form-group">
                        <label>{{ 'LOGIN_PASSWORD' | translate }}</label>
                        <div class="input-group">
                            <span class="input-group-text">
                                <i class="fa fa-lock"></i>
                            </span>
                            <input name="password" class="form-control" [(ngModel)]="loginForm.password" type="password" placeholder="{{ 'LOGIN_PASSWORD' | translate }}">
                        </div>
                    </div>
                    <div class="item-login btn btn-primary btn-block" type="button" (click)="comminEvent()">
                        <ng-content select="[header]" ></ng-content>
                    </div>
                    <ng-content select="[body]"></ng-content>
                    <ng-content select="[keycloak-login]"></ng-content>
                    <ng-content select="[error]"></ng-content>
                </div>
            </div>
        </div>
    </div>
</div>